import {createApp} from 'vue'
import CreateFrivilligJob from './CreateFrivilligJob'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--create-frivillig-job'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreateFrivilligJobDOM)=>{
            const props = handleComponentProps(CreateFrivilligJob, CreateFrivilligJobDOM)
            const component = createApp(CreateFrivilligJob, {
                ...props,
                isEditContext: CreateFrivilligJobDOM.hasAttribute('is-edit-context')
            }).use(Store)
            component.mount(CreateFrivilligJobDOM)
        })
    }
}